import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export type IProduct = {
  productCode: string;
  um: string;
  description: string;
  hasComposition: boolean;
  hasSN: boolean;
  priceRef: number;
  lastSupplier: number;
  lastPrice: number;
  ceCertificate: boolean;
  cbCertificate: boolean;
  averDeliTime: number;
  devType: number;
  price: number;
  ctype: number;
};

export interface ProductsResponse extends ApiResponse {
  products: IProduct[];
  totalRows: number;
}

export const fetchProducts = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  description?: string,
  productCode?: string
): Promise<AxiosResponse<ProductsResponse>> => {
  const url =
    `${zps_ms_ea_war}/product?offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (description ? `&description=${description}` : '') +
    (productCode ? `&likeProductCode=${productCode}` : '');

  return axios.get<ProductsResponse>(url, {
    signal: controller.signal
  });
};

export const addProduct = (
  product: IProduct,
  controller: AbortController
): Promise<AxiosResponse<ProductsResponse>> => {
  return axios.post<ProductsResponse>(`${zps_ms_ea_war}/product`, product, { signal: controller.signal });
};

export const updateProduct = (
  product: IProduct,
  controller: AbortController
): Promise<AxiosResponse<ProductsResponse>> => {
  return axios.put<ProductsResponse>(`${zps_ms_ea_war}/product`, product, { signal: controller.signal });
};

export const deleteProduct = (
  productCode: string,
  controller: AbortController
): Promise<AxiosResponse<ProductsResponse>> => {
  return axios.delete<ProductsResponse>(`${zps_ms_ea_war}/product?productCode=${productCode}`, {
    signal: controller.signal
  });
};
